/* Denner buy box for AW26 (Impulse). Moves the parts rendered by
   sections/denner-aw-buybox.liquid into the theme's buy column and restyles
   price and Add to bag. The theme's own title, options, size and fit and stock
   blocks are not touched. Every step is optional: if an element is missing the
   theme's default stays.
   15 Oct 2026: fixed a freeze on some product pages. The Smile points line was rewritten every time
   it changed, and when its text had no number (e.g. while Smile was still loading) each rewrite
   triggered the next one forever, so the browser showed "Page Unresponsive". Now each line is
   only touched once and only when the text actually changes. */
(function () {
  'use strict';

  var host = document.querySelector('[data-dnr-aw]');
  var meta = document.querySelector('.product-section .product-single__meta') || document.querySelector('.product-single__meta');
  if (!host || !meta) return;
  document.documentElement.classList.add('dnr-aw');

  function $(sel, root) { return (root || meta).querySelector(sel); }
  function part(name) {
    var n = host.querySelector('[data-dnr-part="' + name + '"]');
    return n ? n.firstElementChild : null;
  }
  function after(ref, node) { if (ref && node) ref.parentNode.insertBefore(node, ref.nextSibling); }

  /* 1. category line above the title, Trustpilot line below it ------------ */
  var header = $('.product-block--header');
  var title = $('.product-single__title');
  var eyebrow = part('eyebrow');
  if (title && eyebrow) title.parentNode.insertBefore(eyebrow, title);
  var rating = part('rating');
  if (header && rating) {
    after(header, rating);
    var badge = $('.jdgm-preview-badge');
    var badgeBlock = badge && badge.closest('.product-block, .shopify-app-block');
    if (badgeBlock) badgeBlock.classList.add('dnr-hide');
  }

  /* 2. price: "30% off" instead of "Save x"; spec line under it ----------- */
  var priceBlock = $('.product-block--price');
  after(priceBlock, part('spec'));
  function num(el) { return el ? Number(String(el.textContent).replace(/[^\d]/g, '')) : 0; }
  function syncSavings() {
    var sav = $('[data-save-price]');
    if (!sav) return;
    var now = num($('[data-product-price]'));
    var was = num($('[data-compare-price]'));
    if (was > now && now > 0) {
      var pct = Math.round((was - now) / was * 100) + '% off';
      if (sav.textContent !== pct) sav.textContent = pct;
    }
  }

  /* 3. Add to bag: bag icon left, price right ------------------------------ */
  var add = $('[data-add-to-cart]');
  var BAG = '<svg class="dnr-add__bag" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
  function syncButton() {
    if (!add) return;
    var label = add.querySelector('[data-add-to-cart-text]');
    if (!label) return;
    if (!add.classList.contains('dnr-add')) add.classList.add('dnr-add');
    if (!add.querySelector('.dnr-add__bag')) add.insertAdjacentHTML('afterbegin', BAG);
    var tx = label.textContent.trim();
    if (/^add to cart$/i.test(tx)) label.textContent = 'Add to bag';
    if (label.getAttribute('data-default-text') === 'Add to cart') label.setAttribute('data-default-text', 'Add to bag');
    var pr = add.querySelector('.dnr-add__price');
    if (!pr) {
      pr = document.createElement('span');
      pr.className = 'dnr-add__price';
      add.appendChild(pr);
    }
    var p = $('[data-product-price]');
    var price = p ? p.textContent.trim() : '';
    if (pr.textContent !== price) pr.textContent = price;
    var off = !!add.disabled;
    if (add.classList.contains('dnr-add--off') !== off) add.classList.toggle('dnr-add--off', off);
  }

  function syncAll() { syncSavings(); syncButton(); }
  if ('MutationObserver' in window) {
    var busy = false;
    var mo = new MutationObserver(function () {
      if (busy) return;
      busy = true;
      window.setTimeout(function () { syncAll(); busy = false; }, 0);
    });
    [priceBlock, add].forEach(function (n) {
      if (n) mo.observe(n, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    });
  }
  meta.addEventListener('change', function () { window.setTimeout(syncAll, 30); });
  syncAll();
  window.addEventListener('load', syncAll);

  /* 4. delivery, proof tiles and quote after the buy buttons -------------- */
  var afterbuy = part('afterbuy');
  var formBlock = add && add.closest('.product-block');
  if (afterbuy && formBlock) after(formBlock, afterbuy);

  /* 4b. Pickup and Smile rewards as two matching cards under the delivery
     box. The theme fills the pickup card itself; Smile keeps its own text,
     with the number in bold and "How it works" opening the Smile panel. */
  var delivery = afterbuy && afterbuy.querySelector('.dnr-delivery');
  var pick = meta.querySelector('[data-store-availability-holder]');
  if (pick && delivery) {
    after(delivery, pick);
    pick.classList.add('dnr-pick');
  }
  var pts = meta.querySelector('[id*="smile_points_on_product_page"]');
  if (pts && (delivery || formBlock)) {
    after(pick && delivery ? pick : (delivery || formBlock), pts);
    pts.classList.add('dnr-pts');
    var ptsRewrites = 0;
    var syncPts = function () {
      var p = pts.querySelector('p');
      /* Only rewrite a line once, and only if it holds a number of points. At most 3 rewrites per page,
         so even if Smile keeps replacing its line, the two can never keep triggering each other. */
      if (p && !p.querySelector('strong') && !p.hasAttribute('data-dnr-done') && ptsRewrites < 3) {
        ptsRewrites++;
        var tx = p.textContent.trim();
        var m = tx.match(/^Earn ([\d,]+) Points? when completing this purchase\.?$/i);
        if (m) {
          p.setAttribute('data-dnr-done', '1');
          p.textContent = 'Earn ';
          var s = document.createElement('strong');
          s.textContent = m[1] + ' points';
          p.appendChild(s);
          p.appendChild(document.createTextNode(' with this order'));
        } else if (/[\d,]+\s+points?/i.test(tx)) {
          p.setAttribute('data-dnr-done', '1');
          p.innerHTML = p.innerHTML.replace(/([\d,]+\s+points?)/i, '<strong>$1</strong>');
        }
      }
      var sec = pts.querySelector('section');
      if (sec && !pts.querySelector('.dnr-pts__how') && window.SmileUI && typeof SmileUI.openPanel === 'function') {
        var how = document.createElement('button');
        how.type = 'button';
        how.className = 'dnr-pts__how';
        how.textContent = 'How it works';
        how.addEventListener('click', function () { try { SmileUI.openPanel(); } catch (e) {} });
        sec.appendChild(how);
      }
    };
    syncPts();
    if ('MutationObserver' in window) {
      /* Batch Smile's changes (one check per 50 ms) and stop watching once the line is done. */
      var ptsQueued = false;
      var ptsMo = new MutationObserver(function () {
        if (ptsQueued) return;
        ptsQueued = true;
        window.setTimeout(function () {
          ptsQueued = false;
          syncPts();
          if (ptsRewrites >= 3 || (ptsRewrites >= 1 && pts.querySelector('.dnr-pts__how'))) ptsMo.disconnect();
        }, 50);
      });
      ptsMo.observe(pts, { childList: true, subtree: true });
    }
    /* Smile's script arrives late; keep checking for up to 20 s. */
    var tries = 0;
    var iv = window.setInterval(function () {
      syncPts();
      if (pts.querySelector('.dnr-pts__how') || ++tries > 20) window.clearInterval(iv);
    }, 1000);
  }

  var box = document.querySelector('[data-dnr-delivery]');
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function ukParts() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false });
    var o = {};
    f.formatToParts(new Date()).forEach(function (p) { o[p.type] = Number(p.value); });
    if (o.hour === 24) o.hour = 0;
    return o;
  }
  function addWorkingDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (x.getUTCDay() !== 0 && x.getUTCDay() !== 6) n--; }
    return x;
  }
  function fmt(d, withMonth) { return DAY[d.getUTCDay()] + ' ' + d.getUTCDate() + (withMonth ? ' ' + MON[d.getUTCMonth()] : ''); }
  function renderDelivery() {
    if (!box || !window.Intl) return;
    var cutoff = Number(box.getAttribute('data-cutoff') || 13);
    var aMin = Number(box.getAttribute('data-min') || 2);
    var aMax = Number(box.getAttribute('data-max') || 5);
    var t = ukParts();
    var today = new Date(Date.UTC(t.year, t.month - 1, t.day, 12));
    var wd = today.getUTCDay();
    var sameDay = wd >= 1 && wd <= 5 && t.hour < cutoff;
    var dispatch = sameDay ? today : addWorkingDays(today, 1);
    var from = addWorkingDays(dispatch, aMin), to = addWorkingDays(dispatch, aMax);
    var range = from.getUTCMonth() === to.getUTCMonth() ? fmt(from) + ' – ' + fmt(to, true) : fmt(from, true) + ' – ' + fmt(to, true);
    var lead;
    if (sameDay) {
      var left = cutoff * 60 - (t.hour * 60 + t.minute);
      lead = 'Order within <strong>' + Math.floor(left / 60) + ' h ' + (left % 60) + ' m</strong> for dispatch today';
    } else {
      lead = 'Order now for dispatch <strong>' + fmt(dispatch, true) + '</strong>';
    }
    var html = lead + ' · arrives <strong>' + range + '</strong>. ' + (box.getAttribute('data-tail') || '');
    if (box.innerHTML !== html) box.innerHTML = html;
  }
  renderDelivery();
  window.setInterval(renderDelivery, 60000);

  /* 4c. Phone gallery: a "12 / 91" counter instead of one dot per photo -------
     Impulse draws one page dot per photo under the gallery on phones. With many
     colours (up to 100+ photos) that becomes four rows of dots over the picture,
     so when there are more than 8 photos the dots are hidden and a small counter
     is shown instead. Added 19 Oct 2026. */
  var gal = document.querySelector('.product__main-photos .product-slideshow');
  if (gal) {
    var slides = gal.querySelectorAll('.product-main-slide');
    if (slides.length > 8) {
      var photos = gal.closest('.product__main-photos');
      photos.classList.add('dnr-many');
      var counter = document.createElement('div');
      counter.className = 'dnr-gal-count';
      counter.setAttribute('aria-live', 'polite');
      photos.appendChild(counter);
      var syncCount = function () {
        var cur = gal.querySelector('.product-main-slide.is-selected');
        var i = cur ? Array.prototype.indexOf.call(slides, cur) + 1 : 1;
        var tx = i + ' / ' + slides.length;
        if (counter.textContent !== tx) counter.textContent = tx;
      };
      syncCount();
      if ('MutationObserver' in window) {
        var galQueued = false;
        new MutationObserver(function () {
          if (galQueued) return;
          galQueued = true;
          window.requestAnimationFrame(function () { galQueued = false; syncCount(); });
        }).observe(gal, { attributes: true, attributeFilter: ['class'], subtree: true });
      }
    }
  }

  /* 5. the buy-box quote is not repeated in the reviews section ----------- */
  var q = document.querySelector('[data-dnr-quote]');
  if (q) {
    var key = (q.getAttribute('data-dnr-quote') || '').slice(0, 28).toLowerCase();
    var cards = document.querySelectorAll('.tpq-card');
    if (key && cards.length > 2) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].textContent.toLowerCase().indexOf(key) !== -1) { cards[i].remove(); break; }
      }
    }
  }
})();
